import root from '../../utils/root';

const options = {
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  arrows: false,
};

/**
 * @public
 * Displays logos of the carriers.
 *
 * @param {Array} logos - array of objects with the carriers logos.
 * @return {void}
 */
export default function printLogos(logos) {
  if (logos && logos.length) {
    let htmlLogos = '';
    const attrs = 'class="carrier-logo img-responsive" style="padding:0 20px"';
    for (let i = 0; i < logos.length; i += 1) {
      htmlLogos += `<div><img src="${logos[i].img_url}" ${attrs}></div>`;
    }
    root.jQuery('.carriers-logos')
      .html(htmlLogos)
      .slick(options);
  }
}
